var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.525 4.0874V6.0124C18.525 6.7124 18.0875 7.5874 17.65 8.0249L13.8875 11.3499C13.3625 11.7874 13.0125 12.6624 13.0125 13.3624V17.1249C13.0125 17.6499 12.6625 18.3499 12.225 18.6124L11 19.3999C9.86252 20.0999 8.28752 19.3124 8.28752 17.9124V13.2749C8.28752 12.6624 7.93752 11.8749 7.58752 11.4374L7.17627 11.0087C6.90502 10.7199 6.85252 10.2824 7.07127 9.94115L11.5513 2.74865C11.7088 2.4949 11.9888 2.3374 12.295 2.3374H16.775C17.7375 2.3374 18.525 3.1249 18.525 4.0874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.55635 3.67615L6.4501 8.6549C6.1526 9.13615 5.4701 9.20615 5.07635 8.7949L4.2626 7.9374C3.8251 7.4999 3.4751 6.7124 3.4751 6.1874V4.1749C3.4751 3.1249 4.2626 2.3374 5.2251 2.3374H8.8126C9.4951 2.3374 9.9151 3.0899 9.55635 3.67615Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterWhite);
export default ForwardRef;